module.exports = __webpack_public_path__ + "static/fasade-no-5de621a45692c313a198b4a6c2f12b15.jpg";